import Vue from 'vue'
import App from './App.vue'
import VueNotification from "vue-notification";
import VueSweetalert2 from "vue-sweetalert2";
import VueCookies from "vue-cookies";
import router from './router';
import store from './store';
import http from "./http";
import './utils/fontawesome';
import './utils/filters';
import TokenService from "./services/token.service";
import AutoPermissionService from "./services/autopermission.service";
import 'sweetalert2/dist/sweetalert2.min.css';

import 'bootstrap/dist/css/bootstrap.min.css';

import {Tooltip} from "bootstrap";

import JwPagination from 'jw-vue-pagination';
Vue.component('jw-pagination', JwPagination);


new Tooltip(document.body, {
    selector: "[data-bs-toggle='tooltip']",
    trigger : "hover"
})

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)


/*import 'vuetify/dist/vuetify.min.css';
import 'vuetify/dist/vuetify.min.js';
import Vuetify from "vuetify";
Vue.use(Vuetify);*/





//import VeeValidate from "vee-validate";

//Vue.use(VeeValidate);

//import Vuelidate from "vuelidate";
//Vue.use(Vuelidate);


Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(VueNotification);
Vue.use(VueSweetalert2);
Vue.use(VueCookies);

Vue.directive('perm', {
    inserted: function (el, binding) {
        var s = JSON.stringify
        var permissionName = s(binding.value).replace(/"/g,"");
        console.log(permissionName);
        AutoPermissionService.addAutoPermissionService(permissionName);
    },

})

Vue.directive('permcheck', {
    inserted: function (el, binding, vnode) {

        if (!JSON.parse(localStorage.getItem('permissions'))
            .includes(binding.expression.replace(/'/g, "").replace(/"/g, ""))
        ) {
            vnode.elm.parentElement.removeChild(vnode.elm);
        }
    },
})

Vue.directive('rolecheck', {
    inserted: function (el, binding, vnode) {

        if (!JSON.parse(localStorage.getItem('roles'))
            .includes(binding.expression.replace(/'/g, "").replace(/"/g, ""))
        ) {
            vnode.elm.parentElement.removeChild(vnode.elm);
        }
    },
})




http.init();

if (TokenService.getAccessToken()) {
    http.setHeader();
    http.mountAuthInterceptor();
}

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')
